module.exports = __webpack_public_path__ + "img/pic-2.accd9a68.png";